import React from 'react';
import './AnimatedLogo.css';
import staticLogo from '../images/logo.png';

const AnimatedLogo = () => {
    return (
        <a 
            href="https://canexus.ai/" 
            className="ca-logo-wrapper"
        >
            <img
                src={staticLogo}
                alt="Cloud Ambassadors"
                className="ca-logo-media"
            />
        </a>
    );
};

export default AnimatedLogo;
